import type { Editor } from '@tiptap/vue-3'
import { ref, computed } from 'vue'

export interface SectionValidationError {
  sectionCode: string
  message: string
  position: number
}

export function useSectionValidation() {
  const validationErrors = ref<SectionValidationError[]>([])

  const validateSections = (editor: Editor): boolean => {
    const errors: SectionValidationError[] = []

    // Traverse the document to find all section nodes
    editor.state.doc.descendants((node, pos) => {
      if (node.type.name === 'section') {
        const label = node.attrs.label
        const sectionCode = node.attrs.code

        // Check if label is empty, null, or just whitespace
        if (!label || label.trim() === '') {
          errors.push({
            sectionCode,
            message: 'Titel ist erforderlich',
            position: pos,
          })
        }
      }
    })

    validationErrors.value = errors
    return errors.length === 0
  }

  const getSectionError = (sectionCode: string): SectionValidationError | undefined => {
    return validationErrors.value.find(error => error.sectionCode === sectionCode)
  }

  const hasValidationErrors = computed(() => validationErrors.value.length > 0)

  const clearValidationErrors = () => {
    validationErrors.value = []
  }

  const getValidationSummary = (): string => {
    if (validationErrors.value.length === 0) return ''

    const count = validationErrors.value.length
    return `${count} Sektion${count > 1 ? 'en' : ''} ${count > 1 ? 'haben' : 'hat'} keinen Titel`
  }

  return {
    validationErrors,
    validateSections,
    getSectionError,
    hasValidationErrors,
    clearValidationErrors,
    getValidationSummary,
  }
}
